import { generateBaseQueryKeysList } from '@/queries/utils';

export const OPO_KEYS = {
  main: 'opos',
  contacts: 'opoContacts',
};

export const opoQueryKeys = generateBaseQueryKeysList(OPO_KEYS.main);
export const opoContactQueryKeys = generateBaseQueryKeysList(OPO_KEYS.contacts);
